import send from '../../../common/support/support.js'

document.addEventListener('DOMContentLoaded', () => send('gmyd'))
